module.exports = __webpack_public_path__ + "static/media/DM-Positive-Clip-4.b1fcc3c6.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/success/DM-Positive-Clip-4.mp3
// module id = 126
// module chunks = 0